import { Link, useNavigate } from 'react-router-dom';
import { useIdentity } from 'context/identity-provider';
import styles from './navlinks.module.scss';

const NavLinks: React.FC = () => {
  const { isAuth, signOut } = useIdentity();
  const navigate = useNavigate();

  const logoutHandler = async () => {
    await signOut();
    navigate('/');
  };

  const isLoggedInUi = (
    <div className={`${styles.linkContainer} navLinks`}>
      <Link to="/portal" className={styles.buttonToLink}>portal</Link>
      <span className={styles.linkSeparator}>|</span>
      <button className={styles.buttonToLink} onClick={logoutHandler}>logout</button>
    </div>
  );

  const loggedOutUi = (
    <div className={`${styles.linkContainer} navLinks`}>
      <Link to="/login" className={styles.buttonToLink}>login</Link>
    </div>
  );

  return (
    <div className={styles.navLinksRoot}>
      {isAuth ? isLoggedInUi : loggedOutUi}
    </div>
  );
};

export default NavLinks;
